import { autobind } from 'core-decorators';
import { action } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import { CardApi } from '@intelingu/core/api/CardApi';
import { COMMON_NS } from '@intelingu/core/constants/base.constants';
import { lazyInject } from '@intelingu/core/IoC/container';
import { ExplanationCardStore } from '@intelingu/core/stores/cards/ExplanationCardStore';
import { TopicCardStore } from '@intelingu/core/stores/cards/TopicCardStore';
import { CardStore } from '@intelingu/core/stores/CardStore';
import withTranslation from '@intelingu/core/utils/withTranslation';
import { FormattedString } from '../../../partials/FormattedString';
import {AppStore} from "../../../../stores/AppStore";

export interface TopicOverviewCardProps {
    id: number;
    stack?: boolean;
    t?;
}

@withTranslation(COMMON_NS)
@observer export class TopicOverviewCard extends Component<TopicOverviewCardProps, any> {

    @lazyInject(CardStore) cardStore: CardStore;
    @lazyInject(TopicCardStore) topicCardStore: TopicCardStore;
    @lazyInject(ExplanationCardStore) explanationCardStore: ExplanationCardStore;
    @lazyInject(CardApi) cardApi: CardApi;
    @lazyInject(AppStore) appStore: AppStore;

    componentDidMount(): void {
        if (this.props.id) {
            window.scrollTo(0, 0);
        }

        if (!this.props.stack) {
            document.addEventListener ("keydown", this.hotKeyListener);
        }
    }

    @action.bound continue() {
        this.explanationCardStore.card.is_first_topic_show = false;
        // this.cardStore.skip();

        setTimeout(() => this.appStore.tourTrigger(this.cardStore.currentCard?.id, 'vocabularyExpanded'));
    }

    @action.bound async addToStack(id) {
        const response = await this.cardApi.getTopic(id);
        this.topicCardStore.stack.push(response.data);
    }

    @action.bound async back() {
        this.topicCardStore.stack.splice(-1, 1);
    }

    componentWillUnmount(): void {
        document.removeEventListener('keydown', this.hotKeyListener);
    }

    @autobind hotKeyListener(event) {
        if (event.which === 13 || event.keyCode === 13) {
            this.continue();
        }
    }

    render() {
        const { t, stack } = this.props;
        const { card } = this.topicCardStore;

        const topic = stack ?
            this.topicCardStore.stack[this.topicCardStore.stack.length - 1] :
            card.topic;

        return <div className={'course-card topic-overview-card'}>
            { stack && (
                <div className={'modal-back'}>
                    <a href={''} onClick={e => {
                        e.preventDefault();
                        this.back();
                    }}><i className={'ion ion-md-close'} /></a>
                </div>
            ) }

            <div className={'title-wrapper'}>
                <h1>{ t('trainingNewTheme') }</h1>
                <h2>{ topic.title }</h2>
            </div>

            {/*<div className={'block red'}>
                <h1>Die Regeln</h1>

                <div className={'content'}>
                    { card.topic.rule }
                </div>
            </div>

            <div className={'block'}>
                <h1>Genauer</h1>

                <div className={'content'}>
                    { card.topic.explanation }
                </div>
            </div>*/}

            <div className={'block'}>
                {/*<h1>Beispiele</h1>*/}

                {/*<div className={'content'} dangerouslySetInnerHTML={{ __html: topic.description }} />*/}
                <div className={'content'}>
                    <FormattedString value={topic.description} />
                </div>
            </div>

            { topic.related && topic.related.length > 0 && (
                <div className={'block gray'}>
                    <h1>{ t('trainingRelatedTopics').toUpperCase() }</h1>

                    <div className={'content'}>
                        { topic.related.map(item => (
                            <div key={item.id}><a href={''} className={'related-topic'} onClick={(e) => {
                                e.preventDefault();
                                this.addToStack(item.id)
                            }}>{ item.name }</a></div>
                        )) }
                    </div>
                </div>
            )}

            { !stack && <button onClick={this.continue}>{ t('continue') }</button> }
        </div>
    }

}
